module.exports = __webpack_public_path__ + "static/media/golden_oak.4d8ea126.jpg";